import React from 'react';
import { Package, Search, MapPin, Clock, AlertCircle, Phone } from 'lucide-react';
import ResponsiveNavbar from './ResponsiveNavbar';
import { UserApis } from '../apis/userApi';

function TrackingPage() {
    // Mock location state for now - replace with actual router integration
    const inputValue = '';

    const [trackingDetails, setTrackingDetails] = React.useState<any>('Empty');
    const [trackingId, setTrackingId] = React.useState<any>(inputValue ? inputValue : '');
    const [loader, setLoader] = React.useState<boolean>(false);

    // Mock API function - replace with actual UserApis.trackShipment when available
    // const trackShipment = async (formData: FormData) => {
    //     // Simulate API delay
    //     await new Promise(resolve => setTimeout(resolve, 1500));

    //     // Mock response for demonstration
    //     return {
    //         data: {
    //             data: {
    //                 TrackingDetail: [
    //                     {
    //                         TrackingDate: '2025-01-27 10:30:00',
    //                         TrackingEventName: 'Package delivered successfully',
    //                         TrackingLocation: 'Lagos, Nigeria'
    //                     },
    //                     {
    //                         TrackingDate: '2025-01-27 08:15:00',
    //                         TrackingEventName: 'Out for delivery',
    //                         TrackingLocation: 'Lagos Distribution Center'
    //                     },
    //                     {
    //                         TrackingDate: '2025-01-26 16:45:00',
    //                         TrackingEventName: 'Package arrived at destination facility',
    //                         TrackingLocation: 'Lagos Distribution Center'
    //                     },
    //                     {
    //                         TrackingDate: '2025-01-26 09:20:00',
    //                         TrackingEventName: 'In transit',
    //                         TrackingLocation: 'Abuja Hub'
    //                     },
    //                     {
    //                         TrackingDate: '2025-01-25 14:00:00',
    //                         TrackingEventName: 'Package picked up',
    //                         TrackingLocation: 'Abuja, Nigeria'
    //                     }
    //                 ]
    //             }
    //         }
    //     };
    // };

    const track = React.useCallback((e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoader(true);
        const formData = new FormData()
        formData.append('reference', trackingId)
        UserApis.trackShipment(formData).then(
            (response: any) => {
                if (response?.data) {
                    setTrackingDetails(response?.data?.data);
                    console.log(response?.data?.data?.TrackingDetail);
                    setLoader(false);
                }
            }
        ).catch(function (error) {
            console.log(error.response.data);
        })

    }, [trackingDetails, trackingId]);

    return (
        <>
            <ResponsiveNavbar />
            <div className="min-h-screen bg-gradient-to-br from-slate-50 via-red-50 to-green-50">
                {/* Hero Section */}
                <section className="pt-24 pb-12 px-4 sm:px-6 lg:px-8">
                    <div className="max-w-4xl mx-auto text-center">
                        <div className="inline-flex items-center px-4 py-2 bg-green-100 text-green-700 rounded-full text-sm font-medium mb-6">
                            <Package className="w-4 h-4 mr-2" />
                            Track Your Package
                        </div>
                        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4 leading-tight">
                            Real-Time Package
                            <span className="bg-gradient-to-r from-red-600 to-red-700 bg-clip-text text-transparent"> Tracking</span>
                        </h1>
                        <p className="text-lg text-gray-600 mb-8 max-w-2xl mx-auto">
                            Enter your tracking number to get instant updates on your shipment location and delivery status.
                        </p>
                    </div>
                </section>

                {/* Tracking Form */}
                <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 pb-6">
                    <div className="space-y-6">
                        {/* Tracking Input */}
                        <div className="bg-white rounded-2xl shadow-lg p-6">
                            <div className="flex flex-col sm:flex-row items-end gap-4">
                                <div className="flex-1">
                                    <label className="block mb-3 text-sm font-semibold text-gray-900">
                                        Tracking Number
                                    </label>
                                    <div className="relative">
                                        <Package className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400" />
                                        <input
                                            type="text"
                                            className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-red-500 focus:border-transparent transition-colors text-sm bg-white"
                                            placeholder="Enter your CFL tracking number"
                                            name="TrackingId"
                                            value={trackingId}
                                            onChange={(e: any) => setTrackingId(e?.target?.value)}
                                            onKeyPress={(e) => {
                                                if (e.key === 'Enter') {
                                                    track(e as any);
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                                <button
                                    onClick={(e: any) => track(e)}
                                    disabled={loader || !trackingId.trim()}
                                    className="w-full sm:w-auto bg-gradient-to-r from-red-600 to-red-700 text-white px-6 py-3 rounded-xl font-semibold hover:from-red-700 hover:to-red-800 transition-all duration-300 shadow-lg disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center"
                                >
                                    {loader ? (
                                        <>
                                            <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                                            Tracking...
                                        </>
                                    ) : (
                                        <>
                                            <Search className="w-4 h-4 mr-2" />
                                            Track Package
                                        </>
                                    )}
                                </button>
                            </div>
                        </div>

                        {/* Tracking Results */}
                        <div className="bg-white rounded-2xl shadow-lg overflow-hidden">
                            <div className="p-6 border-b border-gray-200">
                                <h3 className="text-lg font-semibold text-gray-900 flex items-center">
                                    <MapPin className="w-5 h-5 mr-2 text-red-600" />
                                    Tracking Details
                                </h3>
                            </div>

                            <div className="p-6">
                                {loader ? (
                                    <div className="flex flex-col items-center justify-center py-12">
                                        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-red-600 mb-4"></div>
                                        <p className="text-gray-600">Tracking your package...</p>
                                    </div>
                                ) : trackingDetails === 'Empty' ? (
                                    <div className="text-center py-12">
                                        <Package className="w-16 h-16 text-gray-300 mx-auto mb-4" />
                                        <h3 className="text-lg font-medium text-gray-900 mb-2">Enter Tracking Number</h3>
                                        <p className="text-gray-500">
                                            Enter your tracking number above to see your package journey
                                        </p>
                                    </div>
                                ) : (
                                    <div className="max-w-2xl">
                                        {trackingDetails?.TrackingDetail?.slice(0)?.reverse()?.map(
                                            (data: any, index: number) => (
                                                <div key={index} className="relative">
                                                    {data?.TrackingError === '|6|No record to download.' ? (
                                                        <div className="text-center py-8">
                                                            <AlertCircle className="w-12 h-12 text-gray-300 mx-auto mb-4" />
                                                            <p className="text-gray-500 font-medium">No tracking record found!</p>
                                                            <p className="text-sm text-gray-400 mt-2">
                                                                Please check your tracking number and try again.
                                                            </p>
                                                        </div>
                                                    ) : (
                                                        <div className="flex items-start space-x-4 pb-8">
                                                            <div className="flex flex-col items-center">
                                                                <div className="w-6 h-6 bg-red-600 rounded-full flex items-center justify-center relative">
                                                                    <div className="w-2 h-2 bg-white rounded-full"></div>
                                                                </div>
                                                                {index < trackingDetails?.TrackingDetail?.length - 1 && (
                                                                    <div className="w-0.5 h-16 bg-gray-300 mt-2"></div>
                                                                )}
                                                            </div>
                                                            <div className="flex-1 min-w-0">
                                                                <div className="flex items-center space-x-2 mb-2">
                                                                    <MapPin className="w-4 h-4 text-red-600 flex-shrink-0" />
                                                                    <h4 className="font-semibold text-gray-900 text-base">
                                                                        {data?.TrackingLocation}
                                                                    </h4>
                                                                </div>
                                                                <p className="text-gray-700 mb-2 text-sm leading-relaxed">
                                                                    {data?.TrackingEventName}
                                                                </p>
                                                                <div className="flex items-center space-x-2 text-sm text-gray-500">
                                                                    <Clock className="w-3 h-3 flex-shrink-0" />
                                                                    <span>{data?.TrackingDate}</span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            )
                                        )}
                                    </div>
                                )}
                            </div>
                        </div>

                        {/* Help Section */}
                        <div className="bg-white rounded-2xl shadow-lg p-6">
                            <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                                <div>
                                    <h3 className="font-semibold text-gray-900 mb-1">Need Help?</h3>
                                    <p className="text-sm text-gray-600">
                                        Having trouble tracking your package or need assistance?
                                    </p>
                                </div>
                                <div className="flex flex-col sm:flex-row gap-3">
                                    <a
                                        href="tel:08023693696"
                                        className="flex items-center justify-center px-4 py-2 bg-red-100 text-red-700 rounded-xl hover:bg-red-200 transition-colors text-sm font-medium"
                                    >
                                        <Phone className="w-4 h-4 mr-2" />
                                        Call Support
                                    </a>
                                    <a
                                        href="/contact-us"
                                        className="flex items-center justify-center px-4 py-2 border border-gray-300 text-gray-700 rounded-xl hover:border-red-500 hover:text-red-600 transition-colors text-sm font-medium"
                                    >
                                        Contact Us
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* Footer */}
            <footer className="bg-gray-900 text-white py-16 px-4 sm:px-6 lg:px-8">
                <div className="max-w-7xl mx-auto">
                    <div className="grid md:grid-cols-4 gap-8 mb-12">
                        <div>
                            <div className="flex items-center space-x-2 mb-6">
                                <a href='/' className="flex items-center space-x-2">
                                    <img
                                        src="logo.png"
                                        alt="CFL Global Logistics"
                                        className="w-50 h-12 rounded-xl object-contain"
                                    />
                                    <span className="text-xl font-bold text-white">CFL Global</span>
                                </a>

                            </div>
                            <p className="text-gray-400 leading-relaxed">
                                Your trusted logistics partner in Nigeria, connected to the world through the Skynet Worldwide Express network.
                            </p>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-4">Services</h4>
                            <ul className="space-y-2 text-gray-400">
                                <li>Express Document Delivery</li>
                                <li>Parcel & Package Services</li>
                                <li>Haulage & Heavy Cargo</li>
                                <li>International Shipping</li>
                                <li>Customs Clearing</li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-4">Quick Links</h4>
                            <ul className="space-y-2 text-gray-400">
                                <li><a href="/quote" className="hover:text-white transition-colors">Get Quote</a></li>
                                <li><a href="/services" className="hover:text-white transition-colors">Our Services</a></li>
                                <li><a href="/about-us" className="hover:text-white transition-colors">About Us</a></li>
                                <li><a href="/contact-us" className="hover:text-white transition-colors">Contact Us</a></li>
                            </ul>
                        </div>

                        <div>
                            <h4 className="font-semibold mb-4">Contact Info</h4>
                            <div className="space-y-3 text-gray-400">
                                <div className="flex items-center">
                                    <Phone className="w-5 h-5 mr-2" />
                                    <div>
                                        <div>08023693696</div>
                                        <div>08037921992</div>
                                    </div>
                                </div>
                                <div className="flex items-center">
                                    <Clock className="w-5 h-5 mr-2" />
                                    <div className="text-sm">
                                        <div>Mon-Fri: 8:00 AM - 6:00 PM</div>
                                        <div>Sat: 9:00 AM - 4:00 PM</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="border-t border-gray-800 pt-8 text-center text-gray-400">
                        <p>&copy; 2025 CFL Global Logistics Limited. All rights reserved. | A member of Skynet Worldwide Express</p>
                    </div>
                </div>
            </footer>
        </>
    );
}

export default TrackingPage;